var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkRoundedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4388 1.88571C11.7899 1.45938 11.7289 0.829161 11.3025 0.47807C10.8762 0.126978 10.246 0.187967 9.8949 0.614293L11.4388 1.88571ZM4.25016 9.04167L3.47823 9.67737C3.66819 9.90804 3.95135 10.0417 4.25016 10.0417C4.54898 10.0417 4.83213 9.90804 5.02209 9.67737L4.25016 9.04167ZM2.10543 4.86429C1.75433 4.43797 1.12411 4.37698 0.697789 4.72807C0.271464 5.07916 0.210474 5.70938 0.561566 6.13571L2.10543 4.86429ZM9.8949 0.614293L3.47823 8.40596L5.02209 9.67737L11.4388 1.88571L9.8949 0.614293ZM5.02209 8.40596L2.10543 4.86429L0.561566 6.13571L3.47823 9.67737L5.02209 8.40596Z",
    fill: "#59AD78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkRoundedGreen);
export default __webpack_public_path__ + "static/media/check-mark-rounded-green.6babdcafa5d46608e6b7e0c2ffa619b8.svg";
export { ForwardRef as ReactComponent };